import { useEffect, useState } from "react";
import { X, Sparkles, ArrowRight } from "lucide-react";

const DISMISS_KEY = "afri_plyx_ribbon_dismissed_v1";

/** Tiny gradient ribbon shown above AfriMarket Navbar to cross-promo Plyx.
 *  Dismissable, persists per browser. Click body → engages Plyx mode. */
export default function AfriToPlyxRibbon() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(DISMISS_KEY)) setShow(true);
    } catch {
      /* private mode — silently skip */
    }
  }, []);

  if (!show) return null;

  const dismiss = (e) => {
    e.stopPropagation();
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* ignore */ }
    setShow(false);
  };

  const goPlyx = () => {
    window.location.href = "/plyx";
  };

  return (
    <button
      type="button"
      onClick={goPlyx}
      data-testid="afri-to-plyx-ribbon"
      className="w-full block group cursor-pointer"
      style={{
        background: "linear-gradient(90deg, #FF2D7A 0%, #FFB42D 50%, #00E0C7 100%)",
        color: "#0A0A0A",
        padding: "8px 14px",
        textAlign: "center",
        position: "relative",
        fontSize: "13px",
        fontWeight: 600,
        letterSpacing: "0.01em",
        border: "none",
      }}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          maxWidth: "100%",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <Sparkles size={14} aria-hidden="true" />
        <span>
          <strong>Plyx</strong> — our new social commerce app — is launching soon at{" "}
          <strong>plyx.co.uk</strong>
        </span>
        <span
          className="group-hover:translate-x-0.5 transition-transform"
          style={{ display: "inline-flex", alignItems: "center", gap: "4px", fontWeight: 700 }}
        >
          Preview now <ArrowRight size={14} aria-hidden="true" />
        </span>
      </span>
      <span
        role="button"
        tabIndex={0}
        aria-label="Dismiss"
        onClick={dismiss}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") dismiss(e); }}
        data-testid="afri-to-plyx-ribbon-dismiss"
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          padding: "4px",
          display: "inline-flex",
          opacity: 0.65,
          cursor: "pointer",
        }}
      >
        <X size={16} aria-hidden="true" />
      </span>
    </button>
  );
}
